import { Link } from "react-router-dom";
import { CloudRain } from "lucide-react";

export default function CheckoutCancel() {
  return (
    <section
      data-testid="checkout-cancel-page"
      className="min-h-[60vh] bg-brand-cream flex items-center justify-center px-6 py-24"
    >
      <div className="max-w-lg text-center">
        <CloudRain className="w-14 h-14 text-brand-moss/60 mx-auto mb-6" strokeWidth={1.4} />
        <h1 className="font-serif text-4xl lg:text-5xl text-brand-moss leading-tight">
          No rush — your basket is safe.
        </h1>
        <p className="mt-5 text-lg text-brand-moss/75 leading-relaxed">
          You closed the checkout before completing your payment. Whenever you&apos;re
          ready, your selection is waiting.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/shop"
            data-testid="cancel-back-shop"
            className="inline-flex items-center justify-center bg-brand-moss text-brand-gold hover:bg-brand-moss-light px-7 py-3 rounded-full text-sm tracking-wide transition-colors"
          >
            Back to the Shop
          </Link>
          <Link
            to="/"
            className="inline-flex items-center justify-center border border-brand-moss/30 text-brand-moss px-7 py-3 rounded-full text-sm tracking-wide hover:bg-brand-moss/5 transition-colors"
          >
            Home
          </Link>
        </div>
      </div>
    </section>
  );
}
